<template>
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
      <el-card>
        <el-row>
          <el-alert title="详情" description="资质详情展示如下" type="success" :closable="false" show-icon>
            </el-alert>
          </el-row>
          <el-row :gutter="20">
            <el-card
              style="width: 40%; display: inline-block; margin: 20px"
              v-for="(v, index) in form.credentialArr"
              :key="index"
            >
              <div slot="header" class="clearfix">
                <span style="color: rgb(255, 145, 0);font-weight:600">{{v.title}}信息:</span>
              </div>
              <el-form-item label="证照名称:">
                <el-input readonly v-model="v.title" :maxlength=200 placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="证照编号:" >
              <el-input readonly v-model="v.license_no" :maxlength=200 placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="证照文件地址:" >
              <el-input readonly v-model="v.url" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="证照开始日期:" >
              <template slot-scope="scope">
                <span>{{v.begin_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-form-item>
            <el-form-item label="证照结束日期:" >
              <template slot-scope="scope">
                <span>{{v.end_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-form-item>
            <el-form-item>
              <template slot-scope="scope">  
                <el-button type="warning" size="mini">
                  <a :href="v.url" :download="v.title + '.jpg'" style="color: azure;">下载文件</a> 
                </el-button> 
                <el-button type="primary" size="mini" @click="handleEditDistribution(v.url)">预览资质</el-button> 
              </template>
             </el-form-item>
            <!-- <el-dialog title="资质图片" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
              <el-form-item label="">
                  <img :src="img" style="width:300px;"/>
                <el-popover
                  placement="top"
                  width="100"
                  trigger="click"
                  v-model="visible">
                  <img :src="newimageurl" :style="imageStyle" @click="rotateImage" >
                  <el-button type="text" slot="reference">
                      <img :src="img" style="width:50%;height:70%;"  @click="showtitle(img)" >
                  </el-button>
              </el-popover>
              </el-form-item>
            </el-dialog> -->
            <template>
              <el-dialog
                title="资质图片"
                :visible.sync="dialogFormVisible"
                :close-on-click-modal="false"
              >
                <el-form-item label="">
                  <el-popover
                    placement="top"
                    width="500"
                    trigger="click"
                    v-model="popoverVisible"
                  >
                    <img :src="imgUrl" :style="imageStyle" @click="rotateImage" />
                    <template #reference>
                      <img
                        :src="imgUrl"
                        style="cursor: pointer; width: 50%; height: 50%;"
                        @click="popoverVisible = true"
                      />
                    </template>
                  </el-popover>
                </el-form-item>
              </el-dialog>
            </template>
            </el-card>
          </el-row>
        </el-card>
      <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>
  </el-form>
</template>
<script>
import { mapGetters } from "vuex";
import imgPicker from "@/components/imageselect";
import draggable from "vuedraggable";
import {getQualificationDetail} from "../../api/qualification";
export default {
   components: { imgPicker, draggable},
  data() {
    return {
      pickerImgType: "",
      rotateDeg: 0,
      imgDialog: false,
      isGetImage: false,
      total_count: 0,
      dialogFormVisible: false,
      popoverVisible: false,
      imgUrl: '', // 您的图片URL
      // imageStyle: {
      //   width: '100%', // 根据需要调整
      // },
      params: {
        page: 1,
        pagesize: 20,
        sub_unit_num_id:''
      },
      form: {
        credentialArr: [
            {
              title:"",
              license_no: "",
              url: "",
              begin_date: "",
              end_date: "",
              last_updtme:"",
            }
        ]
      },
      loading: false,
      id: "",
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
    imageStyle() {  
      return {  
        transform: `rotate(${this.rotateDeg}deg)`,  
        // 注意：你可能需要调整 width 和 height，或者完全移除它们，取决于你的布局需求  
        width: '110%', // 通常不建议在 img 标签上直接设置百分比宽度，除非你有特定的布局需求  
        height: '110%', // 同上  
      };  
    },
  },
  methods: {
    toAdd() {
      this.form=[];
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList()
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList();
      this.form= row;
      this.id = row.id;
    },
    rotateImage() {
      console.log(this.rotateDeg,'111111111');
      this.rotateDeg = (this.rotateDeg + 90) % 360; // 每次旋转90度  
    },
    showtitle(row){
      this.newimageurl = row
    },
    del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantCredentials(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getQualificationDetail(this.params)
        .then((response) => {
          console.log(response,'11111111111111111');
          this.form.credentialArr = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    getExport(val=0) {
      this.$notify({
        title: '成功',
          message: '正在导出,请稍后...',
          type: 'success'
        })
        getDetailExport(this.params).then(res => {
            if (res.data.data.status) {
              this.$notify({
                title: '成功',
                message: '已加入队列,请到设置中下载!',
                type: 'success'
              })
              // var url = res.data.data.url
              // window.open(url)
            } else {
              this.$notify({
                title: '失败',
                message: '出错了!',
                type: 'error'
              })
            }
          })
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleEditDistribution(row)
    {
      this.imgUrl = row
      this.dialogFormVisible = true
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
     pickImg(data) {
      this.form[this.pickerImgType] = data.url;
      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType) {
      this.pickerImgType = pickerImgType;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
  },
  mounted() {
    if(this.$route.query.sub_unit_num_id){
      this.params.sub_unit_num_id=this.$route.query.sub_unit_num_id
      this.getDataList();
    }
  },
};
</script>
<style scoped lang="scss">
.zzz{
  width: 17%;
  padding: 5px 10px; /* 内边距 */  
  font-size: 14px; /* 字体大小 */  
  cursor: pointer; /* 鼠标悬停时显示为手形图标 */  

  /* 按钮的边框 */  
  border: none; /* 去除边框 */  
  border-radius: 5px; /* 边框圆角 */  

  /* 按钮的背景和文本颜色 */  
  background-color: #d1d5e6; /* 背景颜色 */  
  color: white; /* 文本颜色 */  
  font-weight: 600;
  /* 悬停效果 */  
  transition: background-color 0.3s ease; /* 平滑过渡效果 */
}
.zzz:hover {  
  background-color: #0056b3; /* 鼠标悬停时的背景颜色 */  
} 
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// detail.vue?5201bc07